import { ObjectSchema } from "yup";
import schema from "@/schema";

export const criterioSchema: ObjectSchema<TCriterioRubrica> = schema.object().shape({
  id: schema.string().required().defined().label("Criterio ID"),
  nome: schema.string().required().defined().label("Criterio Nome"),
  descricao: schema.string().required().defined().label("Criterio Descricao"),
  peso: schema.number().required().defined().label("Criterio Peso"),
  escalaMin: schema.number().required().defined().label("Criterio Escala Min"),
  escalaMax: schema.number().required().defined().label("Criterio Escala Max"),
  guiaNotas: schema.object().required().defined().label("Criterio Guia Notas"),
  obrigatorio: schema.boolean().required().defined().label("Criterio Obrigatorio")
});

export type TRubricaIdeiasInput = Pick<TRubricaIdeias, "version" | "descricao" | "criterios">;

const rubricaSchema: ObjectSchema<TRubricaIdeiasInput> = schema
  .object()
  .shape({
    version: schema.string().required().defined().label("Rubrica Version"),
    descricao: schema.string().required().defined().label("Rubrica Descricao"),
    criterios: schema.array().of(criterioSchema).min(1).required().defined().label("Rubrica Critérios")
  })
  .noUnknown()
  .strict()
  .label("Rubrica Ideias");

export default rubricaSchema;
